export default __webpack_public_path__ + "static/media/audio_08_viento.7ae3a5fc.mp3";